/* eslint-disable */

// @ts-nocheck
import React, { useState } from "react";
import { LivestreamLayoutCommonProps } from "../../../types";
import * as Styled from "./Layout7.styled";
import { SmallCard } from "../../event-card/small-card";
import LayoutModal from "../../event-card/FullScreenModal";
import { LayoutHeader } from "../../layouts/LayoutHeader";
import { FilterOption } from "../ToggleFilter/ToggleFilter";
import { filterEventsByType } from "../../../libs/utils/eventFilter";
import { EmptyLiveStreams } from "../../empty-state";

export const Layout7: React.FC<LivestreamLayoutCommonProps> = ({
    events,
    sessionToken,
    isSignedIn,
    activePlans,
    hasFullAccess,
    freeTrialPlanIds,
    onWatchClick
}) => {
    // Layout not yet implemented/planned to implement
    return <></>;
    // const [isModalOpen, setIsModalOpen] = useState(false);
    // const [selectedOption, setSelectedOption] = useState<FilterOption>('All');

    // const handleSeeAllClick = () => {
    //     setIsModalOpen(true);
    // };

    // const handleCloseModal = () => {
    //     setIsModalOpen(false);
    // };

    // const filteredEvents = filterEventsByType(events, selectedOption);

    // if (!events.length) return <EmptyLiveStreams />;

    // return (
    //     <>
    //         <LayoutHeader
    //             title={'Live Streams'}
    //             itemCount={filteredEvents?.length}
    //             selectedOption={selectedOption}
    //             setSelectedOption={setSelectedOption}
    //             onSeeAll={handleSeeAllClick}
    //             padding="20px 10px 20px 0px"
    //             marginTop="0px"
    //             showToggle={true}
    //         />
    //         {filteredEvents.length === 0 ? (
    //             <Styled.EmptyState>
    //                 There are no events currently streaming. Please check back later for updates.
    //             </Styled.EmptyState>
    //         ) : (
    //             <Styled.ListLayout>
    //                 {filteredEvents.map((item: any) => (
    //                     <Styled.ListItem key={item.id}>
    //                         <SmallCard
    //                             event={item}
    //                             cardClick={() => onWatchClick(item)}
    //                             isSelected={false}
    //                             isSignedIn={isSignedIn}
    //                             hasEligiblePlan={
    //                                 isSignedIn &&
    //                                 (!!item.planDetails.length
    //                                     ? !!activePlans.filter((memberPlan) =>
    //                                         item.planDetails?.some(
    //                                             (itemPlan: any) =>
    //                                                 itemPlan?.id === memberPlan.id
    //                                         )
    //                                     ).length ||
    //                                     freeTrialPlanIds.includes(
    //                                         item.planDetails[0]?.id
    //                                     ) ||
    //                                     hasFullAccess
    //                                     : true)
    //                             }
    //                             onWatchClick={onWatchClick}
    //                             bodyWidth="100%"
    //                         />
    //                     </Styled.ListItem>
    //                 ))}
    //             </Styled.ListLayout>
    //         )}

    //         <LayoutModal
    //             show={isModalOpen}
    //             onHide={handleCloseModal}
    //             filteredLiveEvents={events}
    //             isSignedIn={isSignedIn}
    //             activePlans={activePlans}
    //             hasFullAccess={hasFullAccess}
    //             freeTrialPlanIds={freeTrialPlanIds}
    //             onWatchClick={onWatchClick}
    //         />
    //     </>
    // );
};
